import { useNavigate } from "@tanstack/react-router";
import { Box, Typography, Button } from "@mui/material";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        inset: 0,
        textAlign: "center",
        bgcolor: "background.default",
        p: 4
      }}
    >
      <Typography variant="h1" component="h1" sx={{ fontSize: "4rem", mb: 2 }}>
        404
      </Typography>
      <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        It might have been moved or deleted. You can return to the homepage.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => navigate({ to: "/" })}
      >
        Go to Homepage
      </Button>
    </Box>
  );
};
